'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentPage$() {
}
export { $c_Lpresto_AgentPage$ as $c_Lpresto_AgentPage$ };
$p = $c_Lpresto_AgentPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentPage$;
/** @constructor */
function $h_Lpresto_AgentPage$() {
}
export { $h_Lpresto_AgentPage$ as $h_Lpresto_AgentPage$ };
$h_Lpresto_AgentPage$.prototype = $p;
$p.dw = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
});
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 302788372;
});
$p.l = (function() {
  return "AgentPage";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "AgentPage";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lpresto_AgentPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentPage$, "presto.AgentPage$", ({
  Ds: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_AgentPage$ as $d_Lpresto_AgentPage$ };
var $n_Lpresto_AgentPage$;
function $m_Lpresto_AgentPage$() {
  if ((!$n_Lpresto_AgentPage$)) {
    $n_Lpresto_AgentPage$ = new $c_Lpresto_AgentPage$();
  }
  return $n_Lpresto_AgentPage$;
}
export { $m_Lpresto_AgentPage$ as $m_Lpresto_AgentPage$ };
//# sourceMappingURL=presto.-Agent-Page$.js.map
